"use client";

import { MainNav } from "@/components/layout/MainNav";
import { Sidebar } from "@/components/layout/Sidebar";
import { useAuth } from "@/context/AuthContext";
import { useState, useEffect, memo } from "react";
import { useNavigate } from "react-router-dom";

// Memoize the layout content to prevent unnecessary re-renders
const LayoutContent = memo(({ children }: { children: React.ReactNode }) => (
  <div className="flex min-h-screen w-full bg-background">
    <Sidebar />
    <div className="flex flex-1 flex-col h-screen">
      <MainNav />
      <main className="flex-1 overflow-auto p-6 bg-background">{children}</main>
    </div>
  </div>
));

LayoutContent.displayName = "LayoutContent";

const DashboardLayout = memo(function DashboardLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const { user, isLoading } = useAuth();
  const navigate = useNavigate();
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if (!isLoading) {
      if (!user) {
        navigate("/login");
      } else {
        setIsReady(true);
      }
    }
  }, [user, isLoading, navigate]);

  if (!isReady) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent"></div>
      </div>
    );
  }

  return <LayoutContent>{children}</LayoutContent>;
});

export default DashboardLayout;
